import { ApiResponse, apiRequest } from '@/lib/api/request'

/**
 * Cobrança da assinatura e dos pacotes.
 *
 * Substitui o caminho antigo (`POST /payment`, tela `/checkout`), que criava um
 * `Payment` fora da política de taxas e invisível para conciliação, relatórios e
 * contabilidade. Aqui tudo nasce como cobrança e é pago no checkout público
 * `/pay/:token` — o mesmo link que os clientes já usam todo dia.
 */

export interface SubscriptionOpenBilling {
    id: number
    amount: number
    dueDate: string
    status: string
    description: string | null
    category: string | null
    /** Checkout público da cobrança. Null só se o token não existir. */
    payUrl: string | null
}

export interface SubscriptionOverview {
    subscription: {
        id: number
        planId: number
        planName: string | null
        recurrence: string
        status: string
        dueDay: number
        origin: string
        lastPaymentDate: string | null
    } | null
    /** Mensalidade em centavos. */
    amount: number
    trialEndsAt: string | null
    trialDaysRemaining: number
    openBillings: SubscriptionOpenBilling[]
}

export interface IssuedBilling {
    billingId: number
    amount: number
    dueDate: string
    payUrl: string | null
    /** true = a cobrança do período já existia e foi reaproveitada. */
    alreadyExisted?: boolean
}

export async function getSubscriptionOverview(): Promise<
    ApiResponse<SubscriptionOverview>
> {
    return apiRequest<SubscriptionOverview>('subscription-billing/me', {})
}

/** Emite (ou devolve) a mensalidade do período corrente. */
export async function paySubscription(): Promise<ApiResponse<IssuedBilling>> {
    return apiRequest<IssuedBilling>('subscription-billing/pay', {}, 'post')
}

/** Gera a cobrança de um pacote do catálogo ou personalizado. */
export async function buyPack(data: {
    code?: string
    type?: string
    quantity?: number
}): Promise<ApiResponse<IssuedBilling>> {
    return apiRequest<IssuedBilling>('subscription-billing/packs', { data }, 'post')
}
